import React from 'react';
import { AutocompleteSearchFormField, type AutocompleteSearchFormFieldProps } from '~/shared/forms/controls/fields/AutocompleteSearchFormField';
import type { SearchIcdDiagnosisViewModel } from '@generated';
import { useForm } from '~/shared/forms/FormContext';

export interface IcdDiagnosisAutocompleteProps extends Omit<AutocompleteSearchFormFieldProps<'icd-diagnosis'>, 'searchType'> {
	validPdgmDiagnosisFieldName: string;
	disableWarning?: boolean;
}

export function IcdDiagnosisAutocomplete(props: IcdDiagnosisAutocompleteProps) {
	const { formHelpers } = useForm();

	const onChangePassthrough = (selected: SearchIcdDiagnosisViewModel | null) => {
		if (!selected) {
			formHelpers.setFieldValue(props.validPdgmDiagnosisFieldName, false);
		} else {
			formHelpers.setFieldValue(props.validPdgmDiagnosisFieldName, selected.validPdgmDiagnosis);
		}
		if (props.onChangePassThrough) {
			props.onChangePassThrough(selected);
		}
	};

	const validPdgmDiagnosis = formHelpers.values[props.validPdgmDiagnosisFieldName];
	const icdDiagnosisId = formHelpers.values[props.name];

	return (
		<AutocompleteSearchFormField
			{...props}
			searchType="icd-diagnosis"
			onChangePassThrough={onChangePassthrough}
			warningMessage={icdDiagnosisId && !validPdgmDiagnosis && !props.disableWarning ? 'Warning: Invalid PDGM Diagnosis' : undefined}
		/>
	);
}
